<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

@if (content?.type === 'MEDIA_UPLOAD') {
  <div class="audio-preview-element audio-preview-element-position-{{ position }}">
    <div class="v3-audio-player">
      <button type="button" class="v3-audio-player__play-btn" (click)="togglePlay()" [attr.aria-label]="playLabelKey | transloco">
        <svg
          [lucideIcon]="playIcon"
          [size]="18"
          class="v3-audio-player__play-icon"
          [class.v3-audio-player__play-icon--play]="!isPlaying"
        ></svg>
      </button>

      <span class="v3-audio-player__time v3-audio-player__time--current">{{ currentTimeLabel }}</span>

      <div class="v3-audio-player__slider v3-audio-player__slider--seek">
        <div class="v3-audio-player__slider-fill" [style.width.%]="progressPct"></div>
        <input
          type="range"
          class="v3-audio-player__range"
          min="0"
          step="1"
          [max]="duration"
          [value]="currentTime"
          [disabled]="!canSeek"
          [attr.aria-label]="'translations.global.ariaLabels.seekAudio' | transloco"
          [attr.aria-valuetext]="currentTimeLabel"
          (input)="onSeekInput($event)"
        />
      </div>

      <span class="v3-audio-player__time">{{ durationLabel }}</span>

      <div class="v3-audio-player__volume">
        <button type="button" class="v3-audio-player__icon-btn" (click)="toggleMute()" [attr.aria-label]="muteLabelKey | transloco">
          <svg [lucideIcon]="volumeIcon" [size]="18"></svg>
        </button>

        <div class="v3-audio-player__slider v3-audio-player__slider--volume">
          <div class="v3-audio-player__slider-fill" [style.width.%]="volumePct"></div>
          <input
            type="range"
            class="v3-audio-player__range"
            min="0"
            max="1"
            step="0.05"
            [value]="volumeSliderValue"
            [attr.aria-label]="'translations.global.ariaLabels.audioVolume' | transloco"
            (input)="onVolumeInput($event)"
          />
        </div>
      </div>

      <audio
        #audioElement
        class="v3-audio-player__native"
        [src]="audioUrl"
        (play)="onPlay()"
        (pause)="onPause()"
        (ended)="onEnded()"
        (timeupdate)="onTimeUpdate()"
        (loadedmetadata)="onLoadedMetadata()"
        (volumechange)="onVolumeChange()"
      ></audio>
    </div>

    @if (content?.caption) {
      <div class="audio-preview-element__caption-box">
        <p tabindex="0" class="caption-text">
          {{ content?.caption }}
        </p>
      </div>
    }
  </div>
}
